/* eslint-disable max-len */
import QueryString from 'query-string';
import superagent from 'superagent';

export default class Products {
  static getByRut(query) {
    return superagent.get(`https://portalcliente-dev.api.aureolab.cl/api/products/trinidad?${QueryString.stringify(query)}`);
  }
}
